<div class="chat-width-a">
    <!-- <h2 mat-dialog-title class="md-title chat-cont-a">
        <img src='../../assets/images/logoclaro2.png' style='width:32px;height:32px; vertical-align: middle;'>
        <label class='labTitle chatTitle-b'>T&eacute;rminos y Condiciones</label>
    </h2> -->
    <mat-dialog-content class="chat-cont-a">
        <div class="chatJAC">
            <div class="popupcont">
                <div class="basicrow pull-left">
                    <div class="">
                        <b>Ingresar el código de verificación enviado.</b>
                    </div>
                </div>
                <div class="basicrow pull-left m-top-popup">
                    <label class="label-f">
                        Código de verificación
                    </label>
                </div>
                <div class="basicrow text-center ">
                    <div class="">
                        <input class="inp-f ng-pristine ng-untouched ng-valid ng-valid-maxlength" [(ngModel)]="this.code"
                            maxlength="8">
                    </div>
                </div>
                <div class="basicrow text-center m-top-popup-b">
                    <div class="basicrow">
                        <div class="container-fluid">
                            <div class="row-fluid">
                                <div class="col-xs-6 col-md-6 wid-sms">
                                    <a (click)="this.close();" class="blue btns savech centr vcenter">
                                        <span class="tabcell">
                                            <i class="fa fa-angle-left" aria-hidden="true"></i>&nbsp;&nbsp;Cancelar
                                        </span>
                                    </a>
                                </div>

                                <div class="col-xs-6 col-md-6 wid-sms">
                                    <a class="red btns savech centr vcenter">
                                        <span (click)="this.validatecode()" class="tabcell">
                                            Enviar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="basicrow text-center m-top-popup-b">
                    <a (click)="this.resendCode();" class="red btns savech centr vcenter">
                        <span class="tabcell">
                            Reenviar Código
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>